import React, { useContext, useEffect, useState } from "react";
import { DailyPanditBookingAPI } from "../../ApiServices/DailyPanditAPI/DailyPanditApi";
import {
  Link,
  UNSAFE_shouldHydrateRouteLoader,
  useNavigate,
} from "react-router-dom";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import Batuk from "../../assets/images/new/fav-removebg-preview.png";
import { LoaderContext } from "../../AuthContext/AuthContext";
import Breadcrumbs from "../../Components/Breadcrumb";

const DailyBooking = () => {
  const user_id = localStorage.getItem("userID");
  const [searchKeyWord, setSearchKeyWord] = useState("");
  const [dailyPanditPujaListData, setDailyPanditPujaListData] = useState([]);
  const [searchBtnClick, setSearchClicked] = useState(false);
  const { setLoader, loader, selectedLanguageID } = useContext(LoaderContext);
  const navigate = useNavigate();

  useEffect(() => {
    GetMyBookPanditPujaListData();
  }, []);

  useEffect(() => {
    GetMyBookPanditPujaListData();
  }, [selectedLanguageID]);

  useEffect(() => {
    if (searchBtnClick) {
      GetMyBookPanditPujaListData();
      setSearchClicked(false);
    }
  }, [searchBtnClick]);

  const GetMyBookPanditPujaListData = async () => {
    setLoader(true);
    try {
      const response = await DailyPanditBookingAPI(user_id, {
        START: 1,
        END: 10,
        WORD: searchKeyWord,
        LATITUDE: "20.008581",
        LONGITUDE: "73.76413099999999",
      }, selectedLanguageID);

      if (
        response.ResponseCode === "0" &&
        response.ResponseMessage === "list"
      ) {
        setDailyPanditPujaListData(response.DATA);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const viewDetail = (puja) => {

    const newSlug = puja?.DailyPujaSlug;
    navigate(`/services/daily-booking/puja-details/${newSlug}`, {
      state: { puja: puja },
    });
    // navigate("/services/daily-booking/puja-details", {
    //   state: { puja: puja },
    // });
  };

  return (
    <div
      className="container mt-4 mb-3"
      style={{ display: "flex", flexDirection: "column" }}
    >
      {/* <Breadcrumbs
        items={[
          { label: "Home", url: "/" },
          { label: "Products", url: "/products" },
          { label: "Smartphones", url: "/products/smartphones" },
        ]}
      /> */}
      <Breadcrumbs />
      {/* Search Bar */}
      <div className="row mb-3">
        <div className="col-md-6 mx-auto">
          <div
            className="search-box"
            style={{
              position: "relative",
              flex: "1",
              maxWidth: "100%",
              marginRight: "10px",
            }}
          >
            <input
              type="text"
              className="custom-search-input"
              placeholder="Search"
              value={searchKeyWord}
              onChange={(e) => setSearchKeyWord(e.target.value)}
              style={{
                padding: "8px 35px 8px 10px",
                width: "100%",
              }}
            />
            <span
              onClick={() => {
                setSearchClicked(true);
              }}
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                color: "#a52444",
              }}
            >
              <i className="fas fa-search"></i>
            </span>
          </div>
        </div>
      </div>

      {/* Puja List Heading */}
      {/* <h4 className="text-center mb-4" style={{ fontFamily: "Bricolage Grotesque" }}>
        Daily Puja Services
      </h4> */}

      {/* Puja Cards */}
      <div className="row justify-content-start">
        {dailyPanditPujaListData?.length !== 0 ? (
          dailyPanditPujaListData.map((puja, index) => (
            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-4 "

              onClick={() => viewDetail(puja)}
            >
              <div
                className="card shadow-sm  rounded-3 h-100 border bolder-dark"
                style={{ cursor: "pointer", overflow: "hidden" }}
                onClick={() => viewDetail(puja)}
              >
                {/* Image Section */}
                <div className="position-relative">
                  <img
                    src={puja.DP_IMAGE || placeholderImg}
                    alt={puja.DP_NAME}
                    className="card-img-top "
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = placeholderImg;
                    }}
                    style={{
                      height: "150px",
                      objectFit: "cover",
                      borderTopLeftRadius: "12px",
                      borderTopRightRadius: "12px",
                    }}
                  />


                </div>

                {/* Card Body */}
                <div className="card-body p-2 d-flex flex-column">
                  <h6
                    className="card-title fw-bold mb-1"
                    style={{ color: "#8f3246", fontSize: "16px" }}
                  >
                    {puja.DP_NAME}
                  </h6>

                  <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                    {puja.PUJA_TAGLINE || "A powerful ritual description..."}
                  </p>

                  {/* Temple Info */}
                  <div className="d-flex align-items-center">
                    <i className="bi bi-building text-muted "></i>
                    <small className="text-muted">
                      {puja.TEMPLE_NAME || "Nashik"}
                    </small>
                  </div>

                  {/* Price & Button */}
                  <div className="mt-auto">
                    <span
                      className="fw-bold"
                      style={{ fontSize: "16px", color: "#000" }}
                    >
                      ₹
                      {puja.DP_PRICE
                        ? Math.round(puja.DP_PRICE - (puja.DP_DISC || 0))
                        : "N/A"}
                    </span>
                    <button
                      className="btn w-100 mt-2"
                      style={{
                        backgroundColor: "#8f3246",
                        color: "#fff",
                        borderRadius: "8px",
                        textTransform: "none",
                      }}
                    >
                      <span className="blink-text" onClick={() => viewDetail(puja)}>Book Puja Now</span>
                    </button>

                  </div>
                </div>
              </div>
            </div>
          ))
        ) : loader === false ? (
          <div className="d-flex flex-column align-items-center justify-content-center vh-90 text-center mt-4">
            <img
              src={Batuk}
              alt="Empty Cart"
              className="img-fluid mb-3"
              style={{ maxWidth: "200px" }}
            />
            <h5 className="fw-bold text-center">No Pujas available</h5>
            <p className="text-muted">Please explore our other Pujas.</p>
          </div>
        ) : (
          ""
        )}
      </div>


    </div>
  );
};

export default DailyBooking;
